<template>
  <div class="login-page">
    <div class="login-container">
      <span class="back-link" @click="$router.push('/')">← 返回首页</span>
      
      <h1 class="page-title">登录</h1>
      
      <div class="form-section">
        <div class="form-group">
          <label class="form-label">手机号</label>
          <input 
            type="tel" 
            class="form-input" 
            v-model="formData.account" 
            placeholder="请输入手机号"
            :disabled="loading"
          />
        </div>
        
        <div class="form-group">
          <label class="form-label">密码</label>
          <input 
            type="password" 
            class="form-input" 
            v-model="formData.password" 
            placeholder="请输入密码"
            :disabled="loading"
            @keyup.enter="handleLogin"
          />
        </div>
        
        <button 
          type="button" 
          class="btn-submit" 
          @click="handleLogin"
          :disabled="loading"
        >
          {{ loading ? '登录中...' : '登录' }}
        </button>
        
        <p class="form-footer">
          还没有账号？<a @click="$router.push('/register')">立即注册</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { userLogin } from '@/api/index.js'

export default {
  name: 'LoginPage',
  data() {
    return {
      formData: {
        account: '',
        password: ''
      },
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      if (!this.formData.account) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!this.formData.password) {
        this.$message.warning('请输入密码')
        return
      }
      
      this.loading = true
      try {
        const result = await userLogin({
          account: this.formData.account,
          password: this.formData.password
        })
        
        if (result.code === 1) {
          this.$message.success('登录成功')
          // 保存token到localStorage
          localStorage.setItem('token', result.data.userinfo.token)
          localStorage.setItem('userInfo', JSON.stringify(result.data.userinfo))
          
          // 跳转到首页
          setTimeout(() => {
            this.$router.push('/')
          }, 500)
        } else {
          this.$message.error(result.msg || '登录失败')
        }
      } catch (error) {
        console.error('登录失败:', error)
        this.$message.error('登录失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.login-container {
  width: 100%;
  max-width: 360px;
}

.back-link {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 40px;
  transition: color 0.2s;
}

.back-link:hover {
  color: #111;
}

.page-title {
  font-size: 32px;
  font-weight: 800;
  color: #111;
  margin: 0 0 40px 0;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #111;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 15px;
  border: 1px solid #ddd;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  border-color: #111;
}

.btn-submit {
  width: 100%;
  padding: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: #111;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 8px;
}

.btn-submit:hover:not(:disabled) {
  opacity: 0.8;
}

.btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-footer {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 24px 0 0 0;
}

.form-footer a {
  color: #111;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 4px;
}
</style>
